import React from 'react';
import { Mic, MicOff, MonitorUp, PhoneOff, Video, VideoOff } from 'lucide-react';
import VideoTile from './VideoTile';
import { isCandidate } from './useDailyCall';

const Ctl = ({ on, onClick, icon, label, testId, end }) => (
  <button type="button" className={`iv-ctl ${on ? 'is-on' : ''} ${end ? 'is-end' : ''}`} onClick={onClick} aria-label={label} title={label} data-testid={testId}>
    {icon}<span className="iv-ctl-label">{label}</span>
  </button>
);

export function CallControls({ dc, onLeave }) {
  return (
    <div className="vr-controls" data-testid="call-controls">
      <Ctl on={!dc.micOn} onClick={dc.toggleMic} icon={dc.micOn ? <Mic size={16} /> : <MicOff size={16} />} label={dc.micOn ? 'Mute' : 'Unmute'} testId="call-mic-btn" />
      <Ctl on={!dc.camOn} onClick={dc.toggleCam} icon={dc.camOn ? <Video size={16} /> : <VideoOff size={16} />} label={dc.camOn ? 'Camera off' : 'Camera on'} testId="call-cam-btn" />
      <Ctl on={dc.sharing} onClick={dc.toggleScreen} icon={<MonitorUp size={16} />} label={dc.sharing ? 'Stop sharing' : 'Share screen'} testId="call-screen-btn" />
      <Ctl end onClick={onLeave} icon={<PhoneOff size={16} />} label="Leave" testId="call-leave-btn" />
    </div>
  );
}

export default function CallStage({ dc, onLeave, emptyText }) {
  const all = Object.values(dc.participants);
  const screens = all.filter((p) => p.tracks?.screenVideo?.state === 'playable');
  const people = [...all].sort((a, b) => (a.local - b.local) || (isCandidate(b) - isCandidate(a)));
  const alone = people.length <= 1;
  return (
    <div className="vr-stage" data-testid="call-stage">
      {screens.map((p) => <VideoTile key={`${p.session_id}-s`} p={p} screen testId="call-screen-tile" />)}
      <div className={`vr-grid vr-n${Math.min(people.length, 4)}`}>
        {people.map((p) => (
          <VideoTile key={p.session_id} p={p} speaking={dc.speaker === p.session_id && !p.local} badge={isCandidate(p) ? 'Candidate' : p.local ? null : 'Interviewer'}
            testId={p.local ? 'call-tile-local' : `call-tile-${isCandidate(p) ? 'candidate' : 'interviewer'}`} />
        ))}
      </div>
      {alone && <div className="vr-waiting" data-testid="call-waiting">{emptyText}</div>}
      <CallControls dc={dc} onLeave={onLeave} />
    </div>
  );
}
